import axios from 'axios';

const { REACT_APP_API_BASE_URL } = process.env;

export async function getBuildingsGeoJson() {
  const res = await axios({
    url: REACT_APP_API_BASE_URL + '/buildings?geojson=1',
  });
  return res.data;
}

export async function getActiveItemData({ nid }) {
  const url = REACT_APP_API_BASE_URL + `/buildings/${nid}`;
  const res = await axios({
    url,
  });
  return res.data;
}
